export default __webpack_public_path__ + "static/media/Winter_Drapes_Btn.35e06ecd.jpg";